import { BeneficiaryModel } from './../model/beneficiary.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { BaseService } from './base.services';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';

@Injectable()
export class BeneficiaryService extends BaseService {

  constructor(private http: HttpClient,
    public toastr: ToastrService,
    private store: Store<any>) {
    super(toastr);
  }

  getMemberBeneficiaries(accountId: number): Observable<any> {
    return this.http.get(environment.apiUrl + `/member-portal/MemberBeneficiary/account/${accountId}/beneficiaries`, { headers: this.headers() });
  }


  updateBeneficiaries(accountId: number, obj: BeneficiaryModel[]): Observable<any> {
    return this.http.put<BeneficiaryModel[]>(environment.apiUrl + `/member-portal/MemberBeneficiary/account/${accountId}/beneficiaries`, obj, { headers: this.headers() });
  }

}
